import {
  SELLERLIST_FETCHITEMS_LOAD,
  SELLERLIST_FETCHITEMS_SUCCEED,
  SELLERLIST_FETCHITEMS_FAIL,
  SELLERLIST_CHANGETABLE_CHANGE,
  SELLERLIST_SEARCHTABLE_EDIT,
  SELLERLIST_SEARCHTABLE_SEARCH,
  SELLERLIST_FETCHGROUPS_LOAD,
  SELLERLIST_FETCHGROUPS_SUCCEED,
  SELLERLIST_FETCHGROUPS_FAIL,
  SELLERLIST_GROUPFORM_CHANGE,
  SELLERLIST_GROUPFORM_CREATE,
  SELLERLIST_GROUPFORM_CREATE_SUCCEED,
  SELLERLIST_GROUPFORM_CREATE_FAIL,
  SELLERLIST_GROUPFORM_CREATE_LOAD,
  SELLERLIST_GROUPFORM_FETCHITEMS_LOAD,
  SELLERLIST_GROUPFORM_FETCHITEMS_SUCCEED,
  SELLERLIST_GROUPFORM_FETCHITEMS_FAIL,
  SELLERLIST_GROUPFORM_CHANGETABLE_CHANGE,
  SELLERLIST_GROUPFORM_FETCHITEMS_LAZY_LOADING_SUCCEED,
  SELLERLIST_GROUPFORM_FETCHITEMS_CHANGE_PAGINATION,
  SELLERLIST_GROUPFORM_ITEMS_HAS_NO_MORE,
  SELLERLIST_GROUPFORM_FETCH_GROUPITEMS_LOAD,
  SELLERLIST_GROUPFORM_FETCH_GROUPITEMS_SUCCEED,
  SELLERLIST_GROUPFORM_FETCH_GROUPITEMS_FAIL,
  SELLERLIST_GROUPFORM_REMOVE_LOAD,
  SELLERLIST_GROUPFORM_REMOVE_SUCCEED,
  SELLERLIST_GROUPFORM_REMOVE_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case SELLERLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        result: action.result,
        pagination: { ...state.pagination, total: action.total },
      }
    case SELLERLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case SELLERLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case SELLERLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case SELLERLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    case SELLERLIST_FETCHGROUPS_LOAD:
      return {
        ...state,
        sellerGroups: [],
        fetchSellerGroupsError: null,
        isFetchGroupsLoading: true,
      }
    case SELLERLIST_FETCHGROUPS_SUCCEED:
      return {
        ...state,
        sellerGroups: action.sellerGroups,
        isFetchGroupsLoading: false,
      }
    case SELLERLIST_FETCHGROUPS_FAIL:
      return {
        ...state,
        fetchSellerGroupsError: action.fetchGroupsError,
        isFetchGroupsLoading: false,
      }
    case SELLERLIST_GROUPFORM_CHANGE:
      return {
        ...state,
        groupsManagementFormFieldValues: {
          ...state.groupsManagementFormFieldValues,
          ...action.fields,
        },
      }
    case SELLERLIST_GROUPFORM_CREATE_LOAD:
      return {
        ...state,
        groupFormError: null,
        isGroupCreatedSuccess: false,
        isGroupCreatedLoading: true,
      }
    case SELLERLIST_GROUPFORM_CREATE_SUCCEED:
      return {
        ...state,
        groupFormError: null,
        isGroupCreatedSuccess: true,
        isGroupCreatedLoading: false,
      }
    case SELLERLIST_GROUPFORM_CREATE_FAIL:
      return {
        ...state,
        groupFormError: action.groupFormError,
        isGroupCreatedSuccess: false,
        isGroupCreatedLoading: false,
      }
    case SELLERLIST_GROUPFORM_FETCHITEMS_LOAD:
      return {
        ...state,
        sellerListGroupFormItems: state.sellerListGroupFormItems || null,
        groupFormError: null,
        sellerListGroupFormFetchItemsSuccess: false,
        sellerListGroupFormFetchItemsLoading: true,
      }
    case SELLERLIST_GROUPFORM_FETCHITEMS_SUCCEED:
      return {
        ...state,
        sellerListGroupFormItems: [...action.items],
        groupFormError: null,
        sellerListGroupFormFetchItemsSuccess: true,
        sellerListGroupFormFetchItemsLoading: false,
      }
    case SELLERLIST_GROUPFORM_FETCHITEMS_LAZY_LOADING_SUCCEED:
      return {
        ...state,
        sellerListGroupFormItems: [...(state.sellerListGroupFormItems || []), ...action.items],
        groupFormError: null,
        sellerListGroupFormFetchItemsSuccess: true,
        sellerListGroupFormFetchItemsLoading: false,
      }
    case SELLERLIST_GROUPFORM_FETCHITEMS_FAIL:
      return {
        ...state,
        sellerListGroupFormItems: null,
        groupFormError: action.groupFormError,
        sellerListGroupFormFetchItemsSuccess: false,
        sellerListGroupFormFetchItemsLoading: false,
      }
    case SELLERLIST_GROUPFORM_FETCHITEMS_CHANGE_PAGINATION:
      return {
        ...state,
        page: action.page,
      }
    case SELLERLIST_GROUPFORM_ITEMS_HAS_NO_MORE:
      return {
        ...state,
        sellerListGroupFormFetchItemsHasNoMore: action.hasNoMore,
      }
    case SELLERLIST_GROUPFORM_REMOVE_LOAD:
      return {
        ...state,
        groupFormError: null,
        sellerListGroupFormRemoveSuccess: false,
        sellerListGroupFormRemoveLoading: true,
      }
    case SELLERLIST_GROUPFORM_REMOVE_SUCCEED:
      return {
        ...state,
        sellerListGroupFormRemoveSuccess: true,
        sellerListGroupFormRemoveLoading: false,
      }
    case SELLERLIST_GROUPFORM_REMOVE_FAIL:
      return {
        ...state,
        groupFormError: action.groupFormError,
        sellerListGroupFormRemoveSuccess: false,
        sellerListGroupFormRemoveLoading: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerList.js